import { defineMessages } from 'react-intl'

const scope = `procurify.platform.iam.feature-sets.ReportAccessView`

export default defineMessages({
  clearAllConfirmHeader: {
    id: `${scope}.clearAllConfirmHeader`,
    defaultMessage: 'Remove all report access?',
  },
  clearAllConfirmMessage: {
    id: `${scope}.clearAllConfirmMessage`,
    defaultMessage:
      'Are you sure you want to remove all {count} user(s) report permissions from {secondaryCategoryName}?',
  },
  bulkRemoveConfirmHeader: {
    id: `${scope}.bulkRemoveConfirmHeader`,
    defaultMessage: 'Remove access from all {pluralPrimaryOrgCategoryLabel}?',
  },
  bulkRemoveConfirmMessage: {
    id: `${scope}.bulkRemoveConfirmMessage`,
    defaultMessage:
      "Are you sure you want to remove {userFullName}'s report permissions from all {pluralPrimaryOrgCategoryLabel} and {pluralSecondaryOrgCategoryLabel}?",
  },
  removeConfirmButtonText: {
    id: `${scope}.removeConfirmButtonText`,
    defaultMessage: 'Remove',
  },
  primaryCategoryErrorMessage: {
    id: `${scope}.primaryCategoryErrorMessage`,
    defaultMessage:
      'Unable to load {pluralPrimaryOrgCategoryLabel}. Select a {singularPrimaryOrgCategoryLabel} above, or reload the page to try again.',
  },
  cancelButtonText: {
    id: `${scope}.cancelButtonText`,
    defaultMessage: 'Cancel',
  },
})
